/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

import { CosmosImageFragment } from "@cosmos/hygraph-schema";
import { useCosmosComponentContext } from "@components/context";
import { getHygraphImageIds, isHygraphImageSrc } from "@components/utils";

const isSvg = (img: CosmosImageFragment): boolean => {
	const mimeType: string[] = img.mimeType ? img.mimeType.split("/") : [];
	return mimeType.length === 2 && "svg+xml" === mimeType[1];
};

export const useHygraphLogoUrl = (img?: CosmosImageFragment): string => {
	const { hygraphMediaDomain } = useCosmosComponentContext();
	if (!img || !img.url) return "";

	//Only try for hygraph assets
	if (!isHygraphImageSrc(hygraphMediaDomain, img.url)) return img.url;

	const { assetId, environmentId } = getHygraphImageIds(hygraphMediaDomain, img.url);
	if (!assetId || !img.height) return "";

	const envPartStr = environmentId ? `/${environmentId}` : "";

	if (isSvg(img)) {
		return `https://${hygraphMediaDomain}/${assetId}/output=format:webp${envPartStr}`;
	} else {
		return `https://${hygraphMediaDomain}/${assetId}/resize=height:${img.height}/output=format:webp${envPartStr}`;
	}
};
